import { render, staticRenderFns } from "./CustomCheckBox.vue?vue&type=template&id=123c52d4&scoped=true"
import script from "./CustomCheckBox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckBox.vue?vue&type=script&lang=ts"
import style0 from "./CustomCheckBox.vue?vue&type=style&index=0&id=123c52d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c52d4",
  null
  
)

export default component.exports